import { reqPersonalBankList } from '@/routes/BankCard/services';
import { requestBankCardList } from '@/routes/CompanyAccountManagement/services';
import { getContractList } from '@/routes/Contract/services';
import {
  deleteIntercourse,
  getCommonConfig,
  getDefaultInfo,
  getIntercourseDetail,
  getRegisterList,
  printIntercourse,
  register,
  updateIntercourseStatus,
} from '../services';

export default {
  namespace: 'intercourseFunds',
  state: {
    configList: {},
    defaultInfo: {},
  },
  effects: {
    *getCommonConfig({ payload }, { call, put }) {
      const result = yield call(getCommonConfig, payload);
      const groupList = {};
      result?.forEach(({ groupCode, configROS }) => {
        groupList[groupCode] = configROS;
      });
      yield put({
        type: 'update',
        payload: {
          configList: groupList,
        },
      });
    },

    *getRegisterList({ payload }, { call, put }) {
      const result = yield call(getRegisterList, payload);
      return result;
    },

    *getDefaultInfo({ payload }, { call, put }) {
      const result = yield call(getDefaultInfo, payload);
      const departmentList =
        result.departmentList?.map(i => ({
          ...i,
          deptName: `${result.orgName} ${i.deptId === -1 ? '' : '- ' + i.deptName}`,
        })) || [];
      result.departmentList = departmentList;
      yield put({
        type: 'update',
        payload: {
          defaultInfo: result,
        },
      });
      return result;
    },

    *getContractList({ payload }, { call, put }) {
      const result = yield call(getContractList, payload);
      return result;
    },

    *getBankList({ payload }, { call, put }) {
      const result = yield call(reqPersonalBankList, payload);
      return result;
    },

    *getBankCardList({ payload }, { call, put }) {
      const result = yield call(requestBankCardList, payload);
      return result;
    },

    *register({ payload }, { call, put }) {
      const result = yield call(register, payload);
      return result;
    },

    *getIntercourseDetail({ payload }, { call, put }) {
      const result = yield call(getIntercourseDetail, payload);
      return result;
    },

    *updateIntercourseStatus({ payload }, { call, put }) {
      const result = yield call(updateIntercourseStatus, payload);
      return result;
    },

    *deleteIntercourse({ payload }, { call, put }) {
      const result = yield call(deleteIntercourse, payload);
      return result;
    },

    *printIntercourse({ payload }, { call, put }) {
      const result = yield call(printIntercourse, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
